import React from 'react';

import classes from './HrText.module.css';

const hrText = (props) => (
  <div className={classes.HR}>
    <div className={classes.HRLine} />
    <div className={classes.HRText}>{props.children}</div>
    <div className={classes.HRLine} />
  </div>
);

export default hrText;



// WEBPACK FOOTER //
// ./src/components/UI/HrText/HrText.js